import { unplugin } from "./unplugin";

export default unplugin.vite;
